import ApprovalConfiguration from "components/Configuration/approvalConfigration/ApprovalConfiguration";
import Configuration from "components/Configuration/expenseCategory/Configuration";
import SubCategories from "components/Configuration/subCategories/SubCategories";
import React, { useState } from "react";

const Index = () => {
  const [configHandler, setConfigHanlder] = useState("Approval");

  return (
    <div className="main-contents container-fluid">
      <h1 className="mb-3">Configuration</h1>

      <div className="row gx-2 gy-2 ">

        <div className="col-12 col-sm-6 col-md-auto">
          <button
            className={`w-100 px-3 py-2 ${configHandler === "Approval" ? "primary-btn" : "secondary-btn"
              }`}
            onClick={() => setConfigHanlder("Approval")}
            style={{ minWidth: "220px" }}
          >
            Approval Configuration
          </button>
        </div>

        <div className="col-12 col-sm-6 col-md-auto">
          <button
            className={`w-100 px-3 py-2 ${configHandler === "Configuration"
              ? "primary-btn"
              : "secondary-btn"
              }`}
            onClick={() => setConfigHanlder("Configuration")}
            style={{ minWidth: "220px" }}
          >
            Expense Category Requirements
          </button>
        </div>

        <div className="col-12 col-sm-6 col-md-auto">
          <button
            className={`w-100 px-3 py-2 ${configHandler === "Subcategories"
              ? "primary-btn"
              : "secondary-btn"
              }`}
            onClick={() => setConfigHanlder("Subcategories")}
            style={{ minWidth: "220px" }}
          >
            Sub Categories
          </button>
        </div>
      </div>

      <div>
        {configHandler === "Configuration" && <Configuration />}
        {configHandler === "Approval" && <ApprovalConfiguration />}
        {configHandler === "Subcategories" && <SubCategories />}
      </div>
    </div>
  );
};

export default Index;
